<template>
  <v-card
    color="white"
    :height="height"
    :min-height="minHeight"
    :max-height="maxHeight"
    :width="width"
    :min-width="minWidth"
    :max-width="maxWidth"
    :class="{ 'border': flat }"
    class="pa-0"
  >
    <div
      v-if="title || subtitle || $slots.action"
      class="px-5 br-b d-flex align-center justify-space-between"
      :class="$slots.default && !hidden && hidden === null ? 'pt-4 pb-1' : 'py-4'"
    >
      <div :class="classTitle">
        <h3 v-if="title" class="fw500" :class="classTitle">
          {{ title }}
        </h3>
        <h6 class="secondary--text">
          {{ subtitle }}
        </h6>
      </div>
      <div class="d-flex gap-2 align-center my-n1">
        <div v-if="$slots.action">
          <slot name="action"/>
        </div>
        <div v-if="hidden !== null" class="hidden-data">
          <BaseTooltip :tooltip="localStorage.translations.pages.common.buttons[hidden ? 'prosmotr' : 'close']">
            <v-btn icon color="primary" @click="hidden = !hidden" :disabled="disabledHiddenData">
              <svg
                xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                preserveAspectRatio="xMidYMid meet"
                viewBox="1 1 10 10"
                :class="hidden !== null && hidden && $slots.default ? 'icon-rotate' : ''"
              >
                <path
                  fill="currentColor"
                  d="M7.854 5.854a.5.5 0 1 0-.708-.708L6 6.293L4.854 5.146a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l1.5-1.5ZM11 6A5 5 0 1 0 1 6a5 5 0 0 0 10 0ZM6 2a4 4 0 1 1 0 8a4 4 0 0 1 0-8Z"/>
              </svg>
            </v-btn>
          </BaseTooltip>
        </div>
      </div>
    </div>
    <template v-if="hidden === null || $slots.default && hidden">
      <div :class="String(classBody ? classBody : '') + ' ' + (title || subtitle ? 'px-5 pb-5 pt-4' : 'pa-5')">
        <slot />
      </div>
      <template v-if="$slots.footer">
        <v-divider />
        <div :class="classFooter + ' pa-5 ' + backgroundFooter">
          <slot name="footer" />
        </div>
      </template>
    </template>
  </v-card>
</template>

<script>
export default {
  name: "BaseCard",
  props: {
    title: String,
    subtitle: String,
    height: [Number, String],
    minHeight: [Number, String],
    maxHeight: [Number, String],
    width: [Number, String],
    minWidth: [Number, String],
    maxWidth: [Number, String],
    classBody: {
      type: String,
      default: 'd-grid gap-8'
    },
    classFooter: {
      type: String,
      default: 'd-grid gap-8'
    },
    classTitle: {
      type: [String, Object],
      default: ''
    },
    backgroundFooter: {
      type: String,
      default: 'secondary lighten-5'
    },
    hiddenData: {
      type: Boolean,
      default: null,
    },
    disabledHiddenData: Boolean,
    flat: Boolean,
  },
  data: () => ({
    hidden: null
  }),
  mounted() {
    this.hidden = this.hiddenData
  }
}
</script>

<style scoped lang="scss">
.v-card {
  box-shadow: 0 4px 4px rgb(133 133 133 / 25%) !important;
  border-radius: 10px !important;
}

.border {
  box-shadow: none !important;
  border: 1px solid rgba(189, 189, 189, 0.3) !important;
}

.br-b {
  border-bottom: 1px solid rgba(189, 189, 189, 0.3);
}

h3 {
  font-size: 18px;
  color: #2c2c2c;
}

h6 {
  font-size: 0.75rem;
  font-weight: 500;

  @media #{map-get($display-breakpoints, 'xl-only')} {
    font-size: 1rem;

  }

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    font-size: 0.85rem;
  }
}

.hidden-data {
  margin: -1px -2px -2px;
}

svg {
  transition-duration: 0.3s;

  &.icon-rotate {
    transition-duration: 0.3s;
    transform: rotateZ(-180deg);
    transform-origin: center;
  }
}

.rel {
  position: relative;
}

.abs {
  position: absolute;
  top: 0;
  right: 0;
}

.v-divider {
  border-style: dashed;
  border-color: rgba(189, 189, 189, 0.3) !important;
}
</style>